module.exports = __webpack_public_path__ + "static/media/general-service.a8d28941.png";